import reactiveData from './reactiveData.js';
import reactiveProp from './reactiveProp.js';
export default {
  reactiveData: reactiveData,
  reactiveProp: reactiveProp
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-chartjs/es/mixins/index.js
// module id = 881
// module chunks = 0